exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".xsell[data-v-45d641fe] {\n  padding: 1em 0;\n}\n.xsell .title-wrap[data-v-45d641fe] {\n  padding: 1.5em 0;\n}\n.xsell .title-wrap .lovely-script[data-v-45d641fe] {\n  line-height: 1em;\n}\n@media only screen and (min-width: 960px) {\n.xsell[data-v-45d641fe] {\n    padding: 0 10%;\n}\n}\n", ""]);

// exports
